(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dc-footer"]) return;
  try {
    
const dcFooterAccordions = () => {
 const desktop = matchMedia('(min-width:750px)');
 document.querySelectorAll('.dc-footer-links').forEach(menu => {
  if (menu.dataset.dcAccordionReady) return;
  menu.dataset.dcAccordionReady = 'true';
  let animation;
  let expanded = desktop.matches;
  const sync = () => {
   animation?.cancel();
   expanded = desktop.matches;
   menu.open = expanded;
   menu.style.height = '';
   menu.style.overflow = '';
  };
  sync();
  desktop.addEventListener('change',sync);
  menu.querySelector('summary').addEventListener('click',event => {
   if (desktop.matches) return;
   event.preventDefault();
   const start = menu.getBoundingClientRect().height;
   animation?.cancel();
   expanded = !expanded;
   if (matchMedia('(prefers-reduced-motion:reduce)').matches) {menu.open = expanded;return;}
   menu.open = true;
   menu.style.height = '';
   const end = expanded ? menu.getBoundingClientRect().height : menu.querySelector('summary').getBoundingClientRect().height;
   menu.style.overflow = 'hidden';
   animation = menu.animate({height:[start+'px',end+'px']},{duration:320,easing:'cubic-bezier(.22,1,.36,1)'});
   menu.querySelector('.dc-footer-menu-content').animate({opacity:expanded?[0,1]:[1,0],transform:expanded?['translateY(-8px)','translateY(0)']:['translateY(0)','translateY(-8px)']},{duration:240,easing:'ease'});
   animation.onfinish = () => {menu.open = expanded;menu.style.height = '';menu.style.overflow = '';animation = null;};
  });
 });
};
dcFooterAccordions();
document.addEventListener('shopify:section:load',dcFooterAccordions);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dc-header"]) return;
  try {
    
document.addEventListener('click',event=>{const button=event.target.closest('.dc-product-search-toggle');if(!button)return;const header=button.closest('.dc-header');const open=header.classList.toggle('dc-product-search-open');button.setAttribute('aria-expanded',String(open));if(open)header.querySelector('input[name="q"]')?.focus();});
const dcCategoryViewport=window.matchMedia('(max-width:749px)');
const dcCategoryLabels=()=>document.querySelectorAll('[data-dc-all-categories]').forEach(option=>{option.textContent=dcCategoryViewport.matches?option.dataset.mobileLabel:option.dataset.desktopLabel;});
dcCategoryLabels();dcCategoryViewport.addEventListener('change',dcCategoryLabels);
document.addEventListener('shopify:section:load',dcCategoryLabels);
document.querySelectorAll('.dc-dropdown').forEach(detail=>{detail.addEventListener('toggle',()=>{if(detail.open)document.querySelectorAll('.dc-dropdown').forEach(other=>{if(other!==detail)other.open=false})})});document.addEventListener('keydown',event=>{if(event.key==='Escape')document.querySelectorAll('.dc-dropdown').forEach(detail=>{if(detail.open){detail.open=false;detail.querySelector('summary').focus()}})});document.addEventListener('click',event=>{if(!event.target.closest('.dc-dropdown'))document.querySelectorAll('.dc-dropdown').forEach(detail=>{detail.open=false})});
document.querySelectorAll('.dc-mega-tab').forEach(button => {const activate=()=>{const menu=button.closest('.dc-mega');menu.querySelectorAll('.dc-mega-tab').forEach(tab=>{tab.classList.toggle('dc-active',tab===button);tab.setAttribute('aria-expanded',String(tab===button));});menu.querySelectorAll('.dc-mega-panel').forEach(panel=>panel.classList.toggle('dc-active',panel.id===button.dataset.dcPanel));};button.addEventListener('click',activate);button.addEventListener('focus',activate);button.addEventListener('pointerenter',activate);});
document.querySelectorAll('.dc-search').forEach(form=>form.addEventListener('submit',()=>{const category=form.querySelector('[data-dc-search-category]').value;const query=form.querySelector('input[name="q"]');if(category)query.value='product_type:"'+category.replaceAll('"','')+'" '+query.value;}));
const dcHoverMenus = (scope = document) => {
 scope.querySelectorAll('.dc-dropdown').forEach(menu => {
  if (menu.dataset.dcHoverReady) return;
  menu.dataset.dcHoverReady = 'true';
  let closeTimer;
  const canHover = event => event.pointerType !== 'touch' && matchMedia('(hover: hover) and (min-width: 750px)').matches;
  menu.addEventListener('pointerenter', event => {
   if (!canHover(event)) return;
   clearTimeout(closeTimer);
   menu.closest('.dc-nav').querySelectorAll('.dc-dropdown').forEach(other => {if (other !== menu) other.open = false;});
   menu.open = true;
  });
  menu.addEventListener('pointerleave', event => {
   if (!canHover(event)) return;
   clearTimeout(closeTimer);
   closeTimer = setTimeout(() => {if (!menu.matches(':hover') && !menu.contains(document.activeElement)) menu.open = false;}, 180);
  });
  menu.addEventListener('focusout', () => {
   clearTimeout(closeTimer);
   closeTimer = setTimeout(() => {if (!menu.matches(':hover') && !menu.contains(document.activeElement)) menu.open = false;}, 180);
  });
 });
};
dcHoverMenus();
document.addEventListener('shopify:section:load', event => dcHoverMenus(event.target));
const dcStickyHeader = (root = document) => {
 const header = root.querySelector('.dc-header');
 if (!header || header.dataset.dcStickyReady) return;
 header.dataset.dcStickyReady = 'true';
 const update = () => {
  let scrolled = window.scrollY > 8;
  for (let node = header.parentElement; node; node = node.parentElement) {
   if (node.scrollTop > 8) scrolled = true;
  }
  header.classList.toggle('dc-stuck', scrolled);
 };
 document.addEventListener('scroll', update, {passive:true,capture:true});
 update();
};
dcStickyHeader();
document.addEventListener('shopify:section:load', event => dcStickyHeader(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dc-home"] && !Shopify.designMode) return;
  try {
    
  const dcReveal = (scope = document) => {
    if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting) {
            entry.target.classList.add('dc-visible');
            observer.unobserve(entry.target);
          }
        }
      },
      { threshold: 0.08 }
    );
    scope.querySelectorAll('.dc-home > section, .dc-home > .dc-shortcuts').forEach((el) => {
      if (!el.classList.contains('dc-fade-ready')) {
        el.classList.add('dc-fade-ready');
        observer.observe(el);
      }
    });
  };
  dcReveal();
  document.addEventListener('shopify:section:load', (event) => dcReveal(event.target));
  document.querySelectorAll('.dc-carousel-controls').forEach((controls) => {
    const track = controls.previousElementSibling;
    const previous = controls.querySelector('[data-dc-prev]');
    const next = controls.querySelector('[data-dc-next]');
    const update = () => {
      previous.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
    };
    const slide = (direction) =>
      track.scrollBy({
        left: direction * track.clientWidth * 0.8,
        behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth',
      });
    previous.addEventListener('click', () => slide(-1));
    next.addEventListener('click', () => slide(1));
    track.addEventListener('scroll', update, { passive: true });
    new ResizeObserver(update).observe(track);
    update();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
const dcInitStage = (scope = document) => {
 scope.querySelectorAll('.shopify-section[id$="__main_banner"]').forEach(section => {
  if(section.dataset.dcStageReady)return;
  section.dataset.dcStageReady='true';
  const backdrop=section.querySelector('.dc-stage-image');
  const slideshow=section.querySelector('slideshow-component');
  if(!backdrop||!slideshow)return;
  const sync=()=>{const slide=slideshow.querySelector('slideshow-slide[aria-hidden="false"]')||slideshow.querySelector('slideshow-slide:not([aria-hidden="true"])');const image=slide?.querySelector('.slide__image');if(image){const src=image.currentSrc||image.src;if(src){backdrop.removeAttribute('srcset');backdrop.src=src;document.documentElement.style.setProperty('--dc-stage-image','url('+JSON.stringify(src)+')');}}section.style.setProperty('--dc-stage-header-height',Math.max(0,section.getBoundingClientRect().top+window.scrollY)+'px');};
  const observer=new MutationObserver(sync);observer.observe(slideshow,{subtree:true,attributes:true,attributeFilter:['aria-hidden']});
  const resize=new ResizeObserver(sync);resize.observe(document.querySelector('.dc-header'));resize.observe(section);
  slideshow.querySelectorAll('.slide__image').forEach(image=>image.addEventListener('load',sync));sync();
 });
};
dcInitStage();
document.addEventListener('shopify:section:load',()=>dcInitStage());

  } catch(e) { console.error(e); }
})();
})();
